import Dropdown from './dropdown';
import ChatList from './chat-list';
import streamChatService from '../services/stream-chat';
import templateFn from './chat-dropdown.ejs';

class ChatDropdown extends Dropdown {
  constructor(options) {
    super(options)
    this.templateFn = templateFn
    this.updateMessages = this.updateMessages.bind(this)
  }

  init() {
    super.init()
    this.chatList = new ChatList({ parent: this })
  }

  async open() {
    streamChatService.on('unreadCount', this.updateMessages)
    await streamChatService.getChats(false)

    super.open()
  }

  close() {
    streamChatService.off('unreadCount', this.updateMessages)
    super.close()
  }

  async updateMessages() {
    await streamChatService.getChats(true)
  }
}

export default ChatDropdown
